import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../repositories/common/json_query';

export function trackSpecialProjectAdFoxBanner({
  jsonQuery,
  action,
  bannerId,
  campaignId,
  builderId,
}: {
  action: string;
  bannerId: string;
  campaignId: string;
  builderId: string;
  jsonQuery: IJsonQuery;
}) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action,
    label: 'specproject_banner',
    page: {
      extra: {
        is_specproject: true,
        adfox_id: bannerId,
        campaign_id: campaignId,
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: builderId,
      },
    ],
  });
}
